import type * as Types from '../../types/graphql';

import type { ComputedRef, Ref } from 'vue';
import {
  CampaignTemplateEdgeSelectFragmentDoc,
  CampaignTemplateSelectFragmentDoc,
  CampaignSelectFragmentDoc,
} from '../fragments/campaign.generated';
import {
  VariantWithTemplateSelectFragmentDoc,
  VariantSelectFragmentDoc,
  VariantTemplateSelectFragmentDoc,
} from '../fragments/variant.generated';
import { useQuery, type UseQueryOptions } from 'vue-query';
import { appFetcher } from '../../utils/gatewayClient';
export type CampaignTemplatesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.CampaignOrder>;
  where?: Types.InputMaybe<Types.CampaignWhereInput>;
}>;

export type CampaignTemplatesQueryResponse = {
  campaigns?: Types.Maybe<
    Pick<Types.CampaignConnection, 'totalCount'> & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<Types.CampaignEdge, 'cursor'> & {
              node?: Types.Maybe<
                Pick<Types.Campaign, 'id' | 'name' | 'status' | 'type'> & {
                  variants?: Types.Maybe<
                    Array<
                      Types.Maybe<
                        Pick<Types.Variant, 'id' | 'isOrigin' | 'templateSuffix' | 'templateType' | 'themePageID'> & {
                          template?: Types.Maybe<Pick<Types.VariantTemplate, 'id' | 'redirectURL'>>;
                        }
                      >
                    >
                  >;
                  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'status' | 'type'>>;
                }
              >;
            }
          >
        >
      >;
      pageInfo: Pick<Types.PageInfo, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'>;
    }
  >;
};

export const CampaignTemplatesDocument = `
    query campaignTemplates($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: CampaignOrder, $where: CampaignWhereInput) {
  campaigns(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      ...CampaignTemplateEdgeSelect
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${CampaignTemplateEdgeSelectFragmentDoc}
${CampaignTemplateSelectFragmentDoc}
${CampaignSelectFragmentDoc}
${VariantWithTemplateSelectFragmentDoc}
${VariantSelectFragmentDoc}
${VariantTemplateSelectFragmentDoc}`;
export const useCampaignTemplatesQuery = <TData = CampaignTemplatesQueryResponse, TError = unknown>(
  variables?:
    | CampaignTemplatesQueryVariables
    | ComputedRef<CampaignTemplatesQueryVariables>
    | Ref<CampaignTemplatesQueryVariables>,
  options?: UseQueryOptions<CampaignTemplatesQueryResponse, TError, TData>,
) =>
  useQuery<CampaignTemplatesQueryResponse, TError, TData>(
    variables === undefined ? ['campaignTemplates'] : ['campaignTemplates', variables],
    appFetcher<CampaignTemplatesQueryResponse, CampaignTemplatesQueryVariables>(CampaignTemplatesDocument, variables),
    options,
  );

useCampaignTemplatesQuery.getKey = (
  variables?:
    | CampaignTemplatesQueryVariables
    | ComputedRef<CampaignTemplatesQueryVariables>
    | Ref<CampaignTemplatesQueryVariables>,
) => (variables === undefined ? ['campaignTemplates'] : ['campaignTemplates', variables]);
